import { useRef } from "react";
import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";

interface LatestMoviesProps {
  movies: Movie[];
}

export default function LatestMovies({ movies }: LatestMoviesProps) {
  const scroller = useRef<HTMLDivElement | null>(null);

  const scrollBy = (dir: number) => {
    const el = scroller.current;
    if (!el) return;
    el.scrollBy({ left: dir * (el.clientWidth * 0.8), behavior: "smooth" });
  };

  return (
    <section className="w-full px-4 md:px-10 py-12 md:py-16">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex items-end justify-between gap-3 mb-8">
          <div>
            <span className="text-xs font-label tracking-[0.2em] text-primary-500">
              NEW ARRIVALS
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-1">
              最新上线电影
            </h2>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              aria-label="向左滚动"
              onClick={() => scrollBy(-1)}
              className="w-9 h-9 md:w-10 md:h-10 rounded-full border border-background-300 text-foreground-700 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition-colors flex items-center justify-center cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-xl"></i>
            </button>
            <button
              type="button"
              aria-label="向右滚动"
              onClick={() => scrollBy(1)}
              className="w-9 h-9 md:w-10 md:h-10 rounded-full border border-background-300 text-foreground-700 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition-colors flex items-center justify-center cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-xl"></i>
            </button>
          </div>
        </div>

        <div
          ref={scroller}
          className="flex gap-4 overflow-x-auto no-scrollbar pb-2"
        >
          {movies.map((m) => (
            <div key={m.id} className="w-[150px] md:w-[200px] shrink-0">
              <MovieCard movie={m} />
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            浏览更多爱情电影
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}